import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RecordsService } from '@services/records/records.service';

export interface DialogData {
  id: string;
}

@Component({
  selector: 'app-opendialog-confirm-delete-record',
  templateUrl: './opendialog-confirm-delete-record.component.html',
  styleUrls: ['./opendialog-confirm-delete-record.component.scss']
})
export class OpendialogConfirmDeleteRecordComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<OpendialogConfirmDeleteRecordComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private recordsService: RecordsService
  ) { }

  ngOnInit(): void {
  }

  deleteRecord() {
    this.recordsService.deleteRecord(this.data.id).subscribe({
      next: () => { this.dialogRef.close(); }
    });
  }

}
